import { ANSWER_MESSAGE, OrdenExpressGetUserCredentials, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork.js';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes.js';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';


const REQUEST_SAVE_PRODUCT = 'REQUEST_SAVE_PRODUCT';
export const requestSaveProduct = (requestSaveProduct) => (
  {
    type: REQUEST_SAVE_PRODUCT,
    requestSaveProduct
  }
);
export const RESPONSE_SAVE_PRODUCT = 'RESPONSE_SAVE_PRODUCT';
const responseSaveProduct = responseSaveProduct => (
  {
    type: RESPONSE_SAVE_PRODUCT,
    responseSaveProduct
  }
);
export const fromServerSaveProduct = (action$,state$) => action$.pipe(
  ofType(REQUEST_SAVE_PRODUCT),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/product/save', action.requestSaveProduct, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveProduct(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveProduct(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_GET_PRODUCT_CATEGORY = 'REQUEST_GET_PRODUCT_CATEGORY';
export const requestGetProductCategory = () => (
  {
    type: REQUEST_GET_PRODUCT_CATEGORY
  }
);
export const RESPONSE_GET_PRODUCT_CATEGORY = 'RESPONSE_GET_PRODUCT_CATEGORY';
const responseGetProductCategory = responseGetProductCategory => (
  {
    type: RESPONSE_GET_PRODUCT_CATEGORY,
    responseGetProductCategory
  }
);
export const fromServerGetProductCategory = (action$,state$) => action$.pipe(
  ofType(REQUEST_GET_PRODUCT_CATEGORY),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/productCategory/getAll',OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetProductCategory(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetProductCategory(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_GET_MEASURE_UNIT = 'REQUEST_GET_MEASURE_UNIT';
export const requestGetMeasureUnit = () => (
  {
    type: REQUEST_GET_MEASURE_UNIT
  }
);
export const RESPONSE_GET_MEASURE_UNIT = 'RESPONSE_GET_MEASURE_UNIT';
const responseGetMeasureUnit = responseGetMeasureUnit => (
  {
    type: RESPONSE_GET_MEASURE_UNIT,
    responseGetMeasureUnit
  }
);
export const fromServerGetMeasureUnit = (action$,state$) => action$.pipe(
  ofType(REQUEST_GET_MEASURE_UNIT),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/measureUnit/getAll',OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetMeasureUnit(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetMeasureUnit(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_GET_ALL_PRODUCTS = 'REQUEST_GET_ALL_PRODUCTS';
export const requestGetAllProducts = () => (
  {
    type: REQUEST_GET_ALL_PRODUCTS
  }
);
export const RESPONSE_GET_ALL_PRODUCTS = 'RESPONSE_GET_ALL_PRODUCTS';
const responseGetAllProducts = responseGetAllProducts => (
  {
    type: RESPONSE_GET_ALL_PRODUCTS,
    responseGetAllProducts
  }
);
export const fromServerGetAllProducts = (action$,state$) => action$.pipe(
  ofType(REQUEST_GET_ALL_PRODUCTS),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/product/getAll',OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetAllProducts(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetAllProducts(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_GET_PRODUCTS_FILTER = 'REQUEST_GET_PRODUCTS_FILTER';
export const requestGetProductsFilter = (requestGetProductsFilter) => (
  {
    type: REQUEST_GET_PRODUCTS_FILTER,
    requestGetProductsFilter
  }
);
export const RESPONSE_GET_PRODUCTS_FILTER = 'RESPONSE_GET_PRODUCTS_FILTER';
const responseGetProductsFilter = responseGetProductsFilter => (
  {
    type: RESPONSE_GET_PRODUCTS_FILTER,
    responseGetProductsFilter
  }
);
export const fromServerGetProductsFilter = (action$,state$) => action$.pipe(
  ofType(REQUEST_GET_PRODUCTS_FILTER),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/product/getFilter', action.requestGetProductsFilter, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetProductsFilter(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetProductsFilter(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_RESET_STATE_PRODUCTS = 'REQUEST_RESET_STATE_PRODUCTS';
export const requestResetStateProducts = () => (
  {
    type: REQUEST_RESET_STATE_PRODUCTS
  }
);

export default this;